import 
    React, 
    { 
        // useState
    } 
from 'react';
import { Provider } from "react-redux";
import { BrowserRouter } from 'react-router-dom'

import ReduxConfigureStore from './configureStore'

import { ConfigProvider } from 'antd';

/**
 * Config & Constant
 */
import * as CONFIG from '@src/config'
import { THEME } from '@src/constants'

/**
 * Pages
 */
import SSOMaintenance from './page/SSOMaintenance'

/**
 * Service Componnent
 */
import { COMPONENT } from '@src/services/auth'

/**
 * Container
 */
import App from '@main'

/**
 * Style
 */
import './index.css'

/**
 * Configure Store
 */
const store = ReduxConfigureStore()

const { AuthBackgroundTask } = COMPONENT

const ThemedAPP = () => {
    return (
        <ConfigProvider
            theme={{
                token: {
                    colorPrimary: THEME.THEME_COLOR,
                },
            }}
        >
            <App />
        </ConfigProvider>
    )
}

const APPWapper = () => {
    switch(CONFIG.APP_INFO.APP_MAINTENANCE_MODE === 'true') {
        case true: {
            return (
                <SSOMaintenance />
            )
        } 
        case false:
        default: {
            return (
                <>
                    <AuthBackgroundTask />
                    <ThemedAPP />
                </>
            )
        }
    }
}

const ConnectedApp = () => {
    return (
        <Provider store={store}>
            <BrowserRouter>
                {
                    APPWapper()
                }
            </BrowserRouter>
        </Provider>
    );
}

export default ConnectedApp